import React from 'react'
import { Link } from 'react-router-dom'

function home() {
  return (
    <div>
      <div class="jumbotron text-center">
        <h1 class="display-3">Welcome!</h1>
        <p class="lead"><strong>Please go through the documentation</strong> for further instructions on how to complete your account setup.</p>
        <hr />
        <p>
          Having trouble? <Link to={'https://codecanyon.net/user/soft-miner'}>Contact us</Link>
        </p>
        <p class="lead">
          <Link class="btn btn-primary btn-sm" to={'/login'} role="button">Login</Link>
        </p>
      </div>
    </div>
  )
}

export default home
